import T from 'utils/T';
import ex from 'utils/ex';
import PatientName from './PatientName';
import PatientStatus from './PatientStatus';
import PatientSelectButton from './PatientSelectButton';
import Recoil from 'recoil';
import * as AppStore from 'stores/AppStore';
import React from 'react';

import './PatientInfo.css';
import usePatientInfo from 'hooks/communication/usePatientInfo';

export default function PatientInfo(props) {
  const patient_hash = Recoil.useRecoilValue(AppStore.assets.patient_hash);
  const patient_no = Recoil.useRecoilValue(AppStore.assets.patient_no);
  const doctor_info = Recoil.useRecoilValue(AppStore.assets.doctor_info);

  const {
    dr_id,
  } = doctor_info || {};

  const {
    requestPatientInfo
  } = usePatientInfo();
  const patient = React.useMemo(() => patient_hash[patient_no] || {}, [patient_hash, patient_no]);
  const [patient_info, setPatientInfo] = React.useState({});
  React.useEffect(() => {
    if (!dr_id) return;
    if (!patient_no) return;
    requestPatientInfo({ dr_id, patient_no }, (success, data) => {
      if (success) {
        setPatientInfo(() => data.patient_detail);
      }
    });
  }, [dr_id, patient_no, requestPatientInfo]);

  const ref = React.useRef();
  const onClick = React.useCallback(() => {
    ref.current?.click();
  }, []);
  return (
    <div {...ex('PatientInfo', props)}>
      <PatientName {...props} {...{ onClick }} {...{ patient: patient_info || patient }} />
      <PatientStatus {...props} {...{ onClick }} {...{ patient: patient_info || patient }} />
      <PatientSelectButton {...props} {...{ ref }} />
    </div>
  );
}
